<template>
  <a :href="href" v-on="$listeners">
    <button class="dea-portal-button">
      <picture :aria-label="ariaLabel" class="dea-portal__icon">
        <img :src="src" />
      </picture>
    </button>
  </a>
</template>

<script>
/**
 * Componente per la gestione delle icone dei Portali Tematici.
 */
export default {
  name: "PortalButtons",

  props: {
    /**
     * The name of the icon to display.
     */
    name: {
      type: String,
      required: false,
      default: "dea/dea_horizontal",
    },

    /**
     * Descriptive text to be read to screenreaders.
     */
    ariaLabel: {
      type: String,
      default: "icon",
    },

    src: {
      type: String,
      default: "",
    },

    href: {
      type: String,
      default: "",
    },
  },
};
</script>
